import quickPassService from "@/services/quickPassService";

export const state = {
  loadingStatus: false,
  submitted: false,
  qrUrl: null,
  pdfUrl: null
};

export const actions = {
  generateQr({commit}, params) {
    commit("setLoading", true);
    return new Promise((reject) => {
      quickPassService
        .generateQr(params)
        .then((data) => {
          commit("setQrUrl", data.data.data);
          commit("setLoading", false);
          commit("setSubmitted", false);
          this._vm.$toast.success('QR generated successfully');
        })
        .catch((error) => {
          reject(error);
          commit("setQrUrl", null);
          commit("setLoading", false);
          commit("setSubmitted", false);
          this._vm.$toast.error('error');
        });

    });
  },
  resetState({commit}){
    commit("setLoading", false);
    commit("authfack/setPhoneDuplicatedCheck", null,{root:true});
    commit("authfack/setEmailDuplicatedCheck", null,{root:true});
  }
};

export const mutations = {
  setLoading(state, payload) {
    state.loadingStatus = payload;
  },
  setSubmitted(state, payload) {
    state.submitted = payload;
  },
  setQrUrl(state, payload) {
    state.qrUrl = payload;
    if(payload !== null) {
      let pdf = payload;
      pdf = pdf.replace('images','pdf');
      pdf = pdf.replace('png', 'pdf')
      state.pdfUrl = pdf;
    }
  },
  setPdfUrl(state, payload) {
    state.pdfUrl = payload;
  }
};

export const getters = {
  getLoading(state) {
    return state.loadingStatus;
  },
  getSubmitted(state) {
    return state.submitted;
  },
  getQrUrl(state) {
    return state.qrUrl;
  },
  getPdfUrl(state) {
    return state.pdfUrl;
  },
};
